import { AvField, AvForm } from 'availity-reactstrap-validation';
import { useFormik } from 'formik';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Table } from 'reactstrap';
import ResultatForm from './ResultatForm';
import { vehiculeActions } from '../database/vehiculeSlice';
import { vvinaleActions } from './vvinaleSlice';

const initForm = {
    vehicule: null,
};

const VVinalForm = () => {
    const { t } = useTranslation('translation');
    const { entretReg, categVH, etatVH, entrestruc } = useSelector(state => state.data);
    const { isFetching, vehicules } = useSelector(state => state.vehicule);
    const { isFetchingV } = useSelector(state => state.vvinale);

    const [formData, setFormData] = useState(initForm);
    const [show, setShow] = useState(false);
    const [showEA, setShowEA] = useState(false);
    const [result, setResult] = useState(null);

    const dispatch = useDispatch();

    const formik = useFormik({
        initialValues: formData,
        enableReinitialize: true,
        onSubmit: (values) => {
            let payload = {
                data: values.vehicule,
                onSuccess: (data) => {
                    setResult(data);
                }
            };

            dispatch(vvinaleActions.evaluate(payload));

            // if (values?.id > 0) {
            //     dispatch(parametrageActions.updateVvinale(payload));
            // } else {
            //     dispatch(parametrageActions.createVvinale(payload));
            // }
        }
    });

    useEffect(() => {
        load();
    }, []);

    const load = () => {
        let query = {
            criteria: {},
            page: 0,
            size: 5,
        };
        dispatch(vehiculeActions.search(query));
    }

    const { getFieldProps, values } = formik;

    const showVehiculePopup = () => {
        setShow(!show);
        document.body.classList.add("no_padding");
    }


    const showEntreAutrePopup = () => {
        setShowEA(!showEA);
        document.body.classList.add("no_padding");
    }

    const handleVehicule = (checked, vh) => {
        if (!checked) {
            formik.setFieldValue('vehicule', null);
            return;
        }

        // Fetch FULL vehicule data (including documents)
        let payload = {
            id: vh.id,
            onSuccess: (fullVehicule) => {
                console.log(fullVehicule)
                formik.setFieldValue("vehicule", { ...fullVehicule });
            }
        };

        dispatch(vehiculeActions.find(payload));
    };

    const handleExport = () => {
        const payload = {
            data: values.vehicule,
            onSuccess: () => {
                
            }
        };

        dispatch(vvinaleActions.exportData(payload));

    }

    return (
        <React.Fragment>
            {isFetching || isFetchingV ? (
                <div id="preloader">
                    <div id="status">
                        <div className="spinner">
                            <i className="ri-loader-line spin-icon"></i>
                        </div>
                    </div>
                </div>
            ) : (
                <Row>
                    <Col md="8">
                        <AvForm className="needs-validation" onValidSubmit={formik.handleSubmit}>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md="6">
                                            <Button
                                                type="button"
                                                size='sm'
                                                onClick={showVehiculePopup}
                                                color="primary" className="waves-effect waves-light"
                                            >
                                                {t('parametrage.vehicule')}
                                            </Button>


                                        </Col>
                                    </Row>
                                    {formik.values.vehicule && (
                                        <Card className="mt-3 border shadow-sm">
                                            <CardBody>

                                                <h5 className="text-primary mb-3">
                                                    <i className="ri-file-list-3-line me-2"></i>
                                                    {t('parametrage.detailsVehicule')}
                                                </h5>

                                                {/* ==================== CHASSIS & IDENTIFICATION ==================== */}
                                                <h6 className="text-muted">{t('vehiculef.section_chassis')}</h6>

                                                <Row className="mb-2">
                                                    <Col md="4"><b>{t('vehiculef.immatriculation')}:</b> {values.vehicule.immatriculation}</Col>
                                                    <Col md="4"><b>{t('vehiculef.immanterieur')}:</b> {values.vehicule.immanterieur}</Col>
                                                    <Col md="4"><b>{t('vehiculef.numChassis')}:</b> {values.vehicule.numChassis}</Col>
                                                </Row>

                                                <Row className="mb-2">
                                                    <Col md="4"><b>{t('vehiculef.firstMec')}:</b> {values.vehicule.firstMec}</Col>
                                                    <Col md="4"><b>{t('vehiculef.mecMaroc')}:</b> {values.vehicule.mecMaroc}</Col>
                                                    <Col md="4"><b>{t('vehiculef.compteur')}:</b> {values.vehicule.compteur} km</Col>
                                                </Row>

                                                <Row className="mb-2">
                                                    <Col md="4"><b>{t('vehiculef.ageYears')}:</b> {values.vehicule.ageYears}</Col>
                                                    <Col md="4"><b>{t('vehiculef.ageMonths')}:</b> {values.vehicule.ageMonths}</Col>
                                                    <Col md="4"><b>{t('vehiculef.nbrCylindres')}:</b> {values.vehicule.nbrCylindres}</Col>
                                                </Row>

                                                {/* ==================== SINISTRE ==================== */}
                                                <h6 className="text-muted mt-3">{t('vehiculef.section_sinistre')}</h6>

                                                <Row className="mb-2">
                                                    <Col md="4"><b>{t('vehiculef.dateSinistre')}:</b> {values.vehicule.dateSinistre}</Col>
                                                    <Col md="8"><b>{t('vehiculef.etatVehicule')}:</b> {values.vehicule.etatVehicule === 'ETAT_1' ? "Bon" : "Moyen"}</Col>
                                                </Row>

                                                {/* ==================== ADMINISTRATIF ==================== */}
                                                <h6 className="text-muted mt-3">{t('vehiculef.section_admin')}</h6>

                                                <Row className="mb-2">
                                                    <Col md="4"><b>{t('vehiculef.usage')}:</b> {values.vehicule.usage}</Col>
                                                    <Col md="4"><b>{t('vehiculef.ville')}:</b> {values.vehicule.ville?.description}</Col>
                                                    <Col md="4"><b>{t('vehiculef.assurance')}:</b> {values.vehicule.assurance?.description}</Col>
                                                </Row>

                                                <Row className="mb-2">
                                                    <Col md="4"><b>{t('vehiculef.entretReg')}:</b> {values.vehicule.entretReg}</Col>
                                                    <Col md="4"><b>{t('vehiculef.prestataire')}:</b> {values.vehicule?.prestataire?.prestataire}</Col>
                                                    <Col md="4"><b>{t('parametrage.idFiscal')}:</b> {values.vehicule?.prestataire?.identFiscale}</Col>
                                                </Row>

                                                {/* ==================== VALEURS ==================== */}
                                                <h6 className="text-muted mt-3">{t('vehiculef.section_valeurs')}</h6>

                                                <Row className="mb-2">
                                                    <Col md="4"><b>{t('vehiculef.prixAchat')}:</b> {values.vehicule.prixAchat} DH</Col>
                                                    <Col md="4"><b>{t('vehiculef.valMarche')}:</b> {values.vehicule.valMarche} DH</Col>
                                                    <Col md="4"><b>{t('vehiculef.epave')}:</b> {values.vehicule.epave} DH</Col>
                                                </Row>

                                                <Row className="mb-2">
                                                    <Col md="4"><b>{t('vehiculef.devis')}:</b> {values.vehicule.devis} DH</Col>
                                                    <Col md="4"><b>{t('vehiculef.fraisimm')}:</b> {values.vehicule.fraisimm} DH</Col>
                                                    <Col md="4"><b>{t('vehiculef.coefCommercial')}:</b> {values.vehicule.coefCommercial} %</Col>
                                                </Row>

                                            </CardBody>
                                        </Card>
                                    )}
                                    {values.vehicule?.documents?.length > 0 && (
                                        <Card className="mt-3">
                                            <CardHeader>
                                                <i className="ri-folder-2-line me-2"></i>
                                                {t('vehiculef.documents')}
                                            </CardHeader>

                                            <CardBody>
                                                <Row>
                                                    {values.vehicule.documents.map((doc) => (
                                                        <Col md="6" lg="4" key={doc.id}>
                                                            <Card className="shadow-sm mb-3">
                                                                <CardBody>

                                                                    <div className="d-flex align-items-center mb-2">
                                                                        {doc.fileType === 'application/pdf' ?
                                                                            <i className="ri-file-pdf-line text-danger fs-2"></i> :
                                                                            <i className="ri-image-line text-info fs-2"></i>
                                                                        }

                                                                        <div className="ms-2">
                                                                            <b>{doc.filenameUser}</b><br />
                                                                            <small className="text-muted">{doc.createdDate}</small>
                                                                        </div>
                                                                    </div>

                                                                    <div className="d-flex justify-content-between">
                                                                        <Button size="sm" color="info"
                                                                            onClick={() => window.open(doc.path, "__blank")}>
                                                                            <i className="ri-eye-line"></i> {t('actions.view')}
                                                                        </Button>


                                                                    </div>

                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    ))}
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    )}

                                    <Col md="12" className="d-flex justify-content-end">
                                        <Button color="primary" size="sm" className='mx-1' type="submit">{t('actions.calculer')}</Button>
                                        <Button color="primary" size="sm" className='mx-1' onClick={handleExport}>{t('actions.exporter')}</Button>
                                        <Button color="primary" size="sm" className='mx-1' type="submit">{t('actions.save')}</Button>
                                        <Button color="danger" size="sm" type='reset' className="mx-2" onClick={() => setFormData({ ...initForm })}>{t('actions.clear')}</Button>
                                    </Col>
                                </CardBody>
                            </Card>
                        </AvForm>
                    </Col>
                    <Col md="4">
                        <ResultatForm formData={formData} result={result} />
                    </Col>
                </Row>
            )
            }

            <Modal
                size="xl"
                isOpen={show}
                toggle={showVehiculePopup} >
                <ModalHeader toggle={showVehiculePopup}>
                    {t('vehicule')}

                </ModalHeader>
                <ModalBody>
                    <div className="table-responsive">
                        <Table striped className=" mb-0">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>{t('vehiculef.marque')}</th>
                                    <th>{t('vehiculef.modele')}</th>
                                    <th>{t('vehiculef.carburant')}</th>
                                    <th>{t('vehiculef.nbrCylindres')}</th>
                                    <th>{t('vehiculef.puissFiscale')}</th>
                                    <th>{t('vehiculef.prixAchat')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    vehicules
                                        .map(e => {
                                            return (
                                                <tr key={e.id}>
                                                    <td>
                                                        <React.Fragment>
                                                            <div className="form-check mb-3">
                                                                <Input
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    onChange={(event) => handleVehicule(event.target.checked, e)}
                                                                    checked={values.vehicule && values.vehicule.id === e.id}
                                                                />
                                                            </div>
                                                        </React.Fragment>
                                                    </td>
                                                    <td>{e.marque}</td>
                                                    <td>{e.modele}</td>
                                                    <td>{e.carburant}</td>
                                                    <td>{e.nbrCylindres}</td>
                                                    <td>{e.puissFiscale}</td>
                                                    <td>{e.prixAchat}</td>
                                                </tr>
                                            );
                                        })
                                }
                            </tbody>
                        </Table>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        type="button"
                        size='sm'
                        onClick={showVehiculePopup}
                        color="primary"
                        className="waves-effect"
                    >
                        {t('actions.close')}
                    </Button>

                </ModalFooter>
            </Modal>


        </React.Fragment >
    );
};

export default VVinalForm;
